export default __webpack_public_path__ + "static/media/baby-23.4dd6ecb1.svg";